export default class EmailConfirmationCooldown extends Error {
  name = 'EmailConfirmationCooldown';

  constructor(readonly message = 'Email Confirmation Cooldown') {
    super(message);
  }
}
